export default __webpack_public_path__ + "static/media/arrow-desktop.780e76ce.svg";